module.exports = __webpack_public_path__ + "static/media/customer-solution-2.f2ecc509.png";